import React, { useState, useEffect } from "react";
import Table from "../../../../common/table/Table.component";
import SideModal from "../../../../common/modal/SideModal.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import CreateRegister from "../../../components/register-component/CreateRegister.component";
import RegisterClient from "../../../api-services/coders/register/register-client";
import HandlingResponse from "../../../../common/handling-response/handlingResponse";
import ButtonWithComfirmation from "../../../../common/button-with-confirmation/ButtonWithConfirmation.component";

const Register = () => {
  const tableName = 'SP_REGISTER';

  const columns = [
    {
      Header: "Вредност",
      accessor: "value",
      disableFilters: false,
    },
    {
      Header: "Тежина",
      accessor: "weight",
    },
    {
      Header: "Активан",
      accessor: "isActive",
      Cell: ({ row }) => {
          return row.original.isActive && <FontAwesomeIcon icon={solid("check")} />;
      },
    },
    {
      accessor: "edit",
      disableSortBy: true,
      className: "two-buttons-column",
      Cell: ({ row }) => {
        return (
          <>
            <button
              className="btn btn-primary table-btn"
              onClick={() => onEditClick(row.original)}
              type="button"
            >
              <FontAwesomeIcon icon={solid("pencil")} />
            </button>
            <ButtonWithComfirmation
              className="btn btn-danger table-btn" 
              onClick={() => onDeleteClick(row.original.id)}
              contentText={"Уписник ће бити трајно обрисан."}
              handleYesText={"Обриши"}
              >
              <FontAwesomeIcon icon={solid("times")} />
            </ButtonWithComfirmation>
          </>
        );
      },
    },
  ];

  const [register, setRegister] = useState([]);
  const [isCreate, setIsCreate] = useState(true);
  const [show, setShow] = useState(false);
  const [rowData, setRowData] = useState({
    id: 0,
    value: "",
    weight: "",
    isActive: true,
  });
  const client = new RegisterClient;

  useEffect(() => {
    Register();
  }, []);
  
  const showModal = () => setShow(true);
  const hideModal = () => {
    setShow(false);
    setRowData({
      id: 0,
      value: "",
      weight: "",
      isActive: true,
    });
  }

  const onCreateClick = () => {
    setIsCreate(true);
    setRowData({
      id: 0,
      value: "",
      weight: "",
      isActive: true,
    });
    showModal();
  };

  const onEditClick = (row) => {
    setIsCreate(false);
    setRowData(row);
    showModal();
  };

  const onDeleteClick = async (id) => {
    var response = await client.DeleteRegister(id);
    var handledResponse = HandlingResponse(response);
    if(handledResponse !== 'Error') {
      let registerCopy = register.filter((x) => x.id !== id);
      setRegister(registerCopy);
    }
  };

  const Register = async () => {
    await client.Register().then((response) => {
      var handledResponse = HandlingResponse(response);
      handledResponse !== 'Error' && setRegister(handledResponse);
    });
  };
  
  return (
    <>
      <h4>Уписници</h4>
      <div className="text-right">
        <button
          onClick={onCreateClick}
          type="button"
          className="btn btn-primary"
        >
          Додај нови уписник
        </button>
      </div>
      <Table
        columns={columns}
        data={register}
        tableName={tableName}
        rememberFilter={true}
        serverSide={false}
        />
      <SideModal
        show={show}
        handleClose={hideModal}
        title={isCreate ? "Креирање новог уписника" : "Измена уписника"}
      >
        <CreateRegister
          row={rowData}
          isCreate={isCreate}
          handleCallback={() => {
            hideModal();
            Register();
          }}
        />
      </SideModal>
    </>
  );
};

export default Register;
